tinymce.addI18n("tr", {
    "#": "#",
    "Accessibility": "Eri\u015filebilirlik",
    "Accordion": "Akordeon",
    "Accordion body...": "Akordeon g\xf6vdesi...",
    "Accordion summary...": "Akordeon \xf6zeti...",
    "Action": "\u0130\u015flem",
    "Activity": "Etkinlik",
    "Address": "Adres",
    "Advanced": "Geli\u015fmi\u015f",
    "Align": "Hizala",
    "Align center": "Ortala",
    "Align left": "Sola hizala",
    "Align right": "Sa\u011fa hizala",
    "Alignment": "Hizalama",
    "Alignment {0}": "Hizalama {0}",
    "All": "T\xfcm\xfc",
    "Alternative description": "Alternatif a\xe7\u0131klama",
    "Alternative source": "Alternatif kaynak",
    "Alternative source URL": "Alternatif kaynak URL",
    "Anchor": "\xc7apa",
    "Anchor...": "\xc7apa...",
    "Anchors": "\xc7apalar",
    "Animals and Nature": "Hayvanlar ve Do\u011fa",
    "Arrows": "Oklar",
    "B": "M",
    "Background color": "Arkaplan rengi",
    "Background color {0}": "Arka plan rengi {0}",
    "Black": "Siyah",
    "Block": "Blok",
    "Block {0}": "Blok {0}",
    "Blockquote": "Blockquote",
    "Blocks": "Bloklar",
    "Blue": "Mavi",
    "Blue component": "Mavi par\xe7a",
    "Body": "G\xf6vde",
    "Bold": "Kal\u0131n",
    "Border": "Kenar",
    "Border color": "Kenarl\u0131k Rengi",
    "Border style": "Kenar sitili",
    "Border width": "Kenar geni\u015fli\u011fi",
    "Bottom": "Alt",
    "Browse files": "Dosyalara g\xf6z at",
    "Browse for an image": "Bir resim aray\u0131n",
    "Browse links": "Ba\u011flant\u0131lara g\xf6z at",
    "Bullet list": "S\u0131ras\u0131z liste",
    "Cancel": "\u0130ptal",
    "Caption": "Ba\u015fl\u0131k",
    "Cell": "H\xfccre",
    "Cell padding": "H\xfccre i\xe7 bo\u015flu\u011fu",
    "Cell properties": "H\xfccre \xf6zellikleri",
    "Cell spacing": "H\xfccre aral\u0131\u011f\u0131",
    "Cell styles": "H\xfccre stilleri",
    "Cell type": "H\xfccre tipi",
    "Center": "Orta",
    "Characters": "Karakter",
    "Characters (no spaces)": "Karakter (bo\u015fluksuz)",
    "Circle": "Daire",
    "Class": "S\u0131n\u0131f",
    "Clear formatting": "Bi\xe7imi temizle",
    "Close": "Kapat",
    "Code": "Kod",
    "Code sample...": "Kod \xf6rne\u011fi...",
    "Code view": "Kod g\xf6r\xfcn\xfcm\xfc",
    "Color Picker": "Renk Se\xe7ici",
    "Color swatch": "Renk \xf6rne\u011fi",
    "Cols": "S\xfctunlar",
    "Column": "S\xfctun",
    "Column clipboard actions": "S\xfctun panosu eylemleri",
    "Column group": "S\xfctun grubu",
    "Column header": "S\xfct\xfcn ba\u015fl\u0131\u011f\u0131",
    "Constrain proportions": "En - Boy oran\u0131n\u0131 koru",
    "Copy": "Kopyala",
    "Copy column": "S\xfctunu kopyala",
    "Copy row": "Sat\u0131r\u0131 kopyala",
    "Could not find the specified string.": "Belirtilen dizin bulunamad\u0131.",
    "Could not load emojis": "Emojiler y\xfcklenemedi",
    "Count": "Say\u0131m",
    "Currency": "Para birimi",
    "Current window": "Mevcut pencere",
    "Custom color": "\xd6zel Renk",
    "Custom...": "\xd6zel...",
    "Cut": "Kes",
    "Cut column": "S\xfctunu kes",
    "Cut row": "Sat\u0131r\u0131 kes",
    "Dark Blue": "Lacivert",
    "Dark Gray": "Koyu Gri",
    "Dark Green": "Koyu Ye\u015fil",
    "Dark Orange": "Koyu Turuncu",
    "Dark Purple": "Koyu Mor",
    "Dark Red": "Koyu K\u0131rm\u0131z\u0131",
    "Dark Turquoise": "Koyu Turkuaz",
    "Dark Yellow": "Koyu Sar\u0131",
    "Dashed": "Kesikli",
    "Date/time": "Tarih/zaman",
    "Decrease indent": "Girintiyi azalt",
    "Default": "Varsay\u0131lan",
    "Delete accordion": "Akordeon'u sil",
    "Delete column": "S\xfctunu sil",
    "Delete row": "Sat\u0131r\u0131 sil",
    "Delete table": "Tabloyu sil",
    "Dimensions": "Boyutlar",
    "Disc": "Disk",
    "Div": "Div",
    "Document": "Belge",
    "Dotted": "Noktal\u0131",
    "Double": "\xc7ift",
    "Drop an image here": "Buraya bir resim koyun",
    "Dropped file type is not supported": "S\xfcr\xfcklenen dosya tipi desteklenmiyor",
    "Edit": "D\xfczenle",
    "Embed": "G\xf6mme",
    "Emojis": "Emojiler",
    "Emojis...": "Emojiler...",
    "Error": "Hata",
    "Error: Form submit field collision.": "Hata: Form g\xf6nderme alan\u0131 \xe7at\u0131\u015fmas\u0131.",
    "Error: No form element found.": "Hata: Form eleman\u0131 bulunamad\u0131.",
    "Extended Latin": "Uzat\u0131lm\u0131\u015f Latin",
    "Failed to initialize plugin: {0}": "Eklenti ba\u015flat\u0131lamad\u0131: {0}",
    "Failed to load plugin url: {0}": "Url eklentisi y\xfcklenemedi: {0}",
    "Failed to load plugin: {0} from url {1}": "Eklenti y\xfcklenemedi: {1} url\u2019sinden {0}",
    "Failed to upload image: {0}": "Resim y\xfcklenemedi: {0}",
    "File": "Dosya",
    "Find": "Bul",
    "Find (if searchreplace plugin activated)": "Bul (SearchReplace eklentisi aktif ise)",
    "Find and Replace": "Bul ve De\u011fi\u015ftir",
    "Find and replace...": "Bul ve de\u011fi\u015ftir...",
    "Find in selection": "Se\xe7im i\xe7inde bul",
    "Find whole words only": "Sadece t\xfcm kelimeyi ara",
    "Flags": "Bayraklar",
    "Focus to contextual toolbar": "Ba\u011flamsal ara\xe7 \xe7ubu\u011funa odaklan",
    "Focus to element path": "Eleman yoluna odaklan",
    "Focus to menubar": "Men\xfc \xe7ubu\u011funa odaklan",
    "Focus to toolbar": "Ara\xe7 \xe7ubu\u011funa odaklan",
    "Font": "Yaz\u0131 Tipi",
    "Font size {0}": "Yaz\u0131 tipi boyutu {0}",
    "Font sizes": "Yaz\u0131 tipi boyutu",
    "Font {0}": "Yaz\u0131 tipi {0}",
    "Fonts": "Yaz\u0131 Tipleri",
    "Food and Drink": "Yiyecek ve \u0130\xe7ecek",
    "Footer": "Footer",
    "Format": "Bi\xe7im",
    "Format {0}": "Bi\xe7im {0}",
    "Formats": "Bi\xe7imler",
    "Fullscreen": "Tam ekran",
    "G": "Y",
    "General": "Genel",
    "Gray": "Gri",
    "Green": "Ye\u015fil",
    "Green component": "Ye\u015fil par\xe7a",
    "Groove": "Oluk",
    "Handy Shortcuts": "Kullan\u0131\u015fl\u0131 K\u0131sayollar",
    "Header": "Header",
    "Header cell": "Ba\u015fl\u0131k h\xfccresi",
    "Heading 1": "Ba\u015fl\u0131k 1",
    "Heading 2": "Ba\u015fl\u0131k 2",
    "Heading 3": "Ba\u015fl\u0131k 3",
    "Heading 4": "Ba\u015fl\u0131k 4",
    "Heading 5": "Ba\u015fl\u0131k 5",
    "Heading 6": "Ba\u015fl\u0131k 6",
    "Headings": "Ba\u015fl\u0131klar",
    "Height": "Y\xfckseklik",
    "Help": "Yard\u0131m",
    "Hex color code": "Hex renk kodu",
    "Hidden": "Gizli",
    "Horizontal align": "Yatay hizalama",
    "Horizontal line": "Yatay \xe7izgi",
    "Horizontal space": "Yatay bo\u015fluk",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "ID bir harfle ba\u015flamal\u0131, ard\u0131ndan yaln\u0131zca harf, say\u0131, tire, nokta, iki nokta \xfcst \xfcste veya alt \xe7izgi gelmelidir.",
    "Image is decorative": "Resim dekoratif",
    "Image list": "Resim listesi",
    "Image title": "Resim ba\u015fl\u0131\u011f\u0131",
    "Image...": "Resim...",
    "ImageProxy HTTP error: Could not find Image Proxy": "ImageProxy HTTP hatas\u0131: G\xf6rsel Proxy bulunamad\u0131",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "ImageProxy HTTP hatas\u0131: Ge\xe7ersiz G\xf6rsel Proxy URL'i",
    "ImageProxy HTTP error: Rejected request": "ImageProxy HTTP hatas\u0131: \u0130stek reddedildi",
    "ImageProxy HTTP error: Unknown ImageProxy error": "ImageProxy HTTP hatas\u0131: Bilinmeyen ImageProxy hatas\u0131",
    "Increase indent": "Girintiyi art\u0131r",
    "Inline": "Sat\u0131r i\xe7i",
    "Insert": "Ekle",
    "Insert Template": "\u015eablon Ekle",
    "Insert accordion": "Akordeon ekle",
    "Insert column after": "Sonras\u0131na yeni s\xfctun ekle",
    "Insert column before": "\xd6ncesine yeni s\xfctun ekle",
    "Insert date/time": "Tarih / Zaman ekle",
    "Insert image": "Resim ekle",
    "Insert link (if link plugin activated)": "Link ekle (Link eklentisi aktif ise)",
    "Insert row after": "Sonras\u0131na yeni sat\u0131r ekle",
    "Insert row before": "\xd6ncesine yeni sat\u0131r ekle",
    "Insert table": "Tablo ekle",
    "Insert template...": "\u015eablon ekle...",
    "Insert video": "Video ekle",
    "Insert/Edit code sample": "Kod \xf6rne\u011fini Kaydet/D\xfczenle",
    "Insert/edit image": "Resim ekle/d\xfczenle",
    "Insert/edit link": "Ba\u011flant\u0131 ekle/d\xfczenle",
    "Insert/edit media": "Medya ekle/d\xfczenle",
    "Insert/edit video": "Video ekle/d\xfczenle",
    "Inset": "\u0130\xe7 metin",
    "Invalid hex color code: {0}": "Ge\xe7ersiz hex renk kodu: {0}",
    "Invalid input": "Ge\xe7ersiz input",
    "Italic": "\u0130talik",
    "Justify": "\u0130ki yana yasla",
    "Keyboard Navigation": "Klavye Tu\u015flar\u0131",
    "Language": "Dil",
    "Learn more...": "Daha fazla bilgi edinin...",
    "Left": "Sol",
    "Left to right": "Soldan sa\u011fa",
    "Light Blue": "A\xe7\u0131k Mavi",
    "Light Gray": "A\xe7\u0131k Gri",
    "Light Green": "A\xe7\u0131k Ye\u015fil",
    "Light Purple": "A\xe7\u0131k Mor",
    "Light Red": "A\xe7\u0131k K\u0131rm\u0131z\u0131",
    "Light Yellow": "A\xe7\u0131k Sar\u0131",
    "Line height": "Sat\u0131r y\xfcksekli\u011fi",
    "Link list": "Link listesi",
    "Link...": "Ba\u011flant\u0131...",
    "List Properties": "\xd6zellikleri listele",
    "List properties...": "Liste \xf6zellikleri",
    "Loading emojis...": "Emojiler y\xfckleniyor...",
    "Loading...": "Y\xfckleniyor...",
    "Lower Alpha": "K\xfc\xe7\xfck Harf",
    "Lower Greek": "K\xfc\xe7\xfck Yunan alfabesi",
    "Lower Roman": "K\xfc\xe7\xfck Roman",
    "Match case": "B\xfcy\xfck / K\xfc\xe7\xfck harfe duyarl\u0131",
    "Mathematical": "Matematik",
    "Media poster (Image URL)": "Medya posteri (Resim URL)",
    "Media...": "Medya...",
    "Medium Blue": "Donuk Mavi",
    "Medium Gray": "Orta Gri",
    "Medium Purple": "Orta Mor",
    "Merge cells": "H\xfccreleri birle\u015ftir",
    "Middle": "Orta",
    "Midnight Blue": "Gece Yar\u0131s\u0131 Mavisi",
    "More...": "Devam\u0131...",
    "Name": "\u0130sim",
    "Navy Blue": "Lacivert",
    "New document": "Yeni dok\xfcman",
    "New window": "Yeni pencere",
    "Next": "\u0130leri",
    "No": "Hay\u0131r",
    "No alignment": "Hizalama yok",
    "No color": "Renk Yok",
    "Nonbreaking space": "B\xf6l\xfcnemez bo\u015fluk",
    "None": "Yok",
    "Numbered list": "S\u0131ral\u0131 liste",
    "OR": "VEYA",
    "Objects": "Nesneler",
    "Ok": "Tamam",
    "Open help dialog": "Yard\u0131m penceresini a\xe7",
    "Open link": "Linki a\xe7",
    "Open link in...": "Ba\u011flant\u0131y\u0131 a\xe7...",
    "Open popup menu for split buttons": "\xc7ok i\u015flevli butonlar i\xe7in a\xe7\u0131l\u0131r men\xfc a\xe7",
    "Orange": "Turuncu",
    "Outset": "D\u0131\u015f Metin",
    "Page break": "Sayfa sonu",
    "Paragraph": "Paragraf",
    "Paste": "Yap\u0131\u015ft\u0131r",
    "Paste as text": "Metin olarak yap\u0131\u015ft\u0131r",
    "Paste column after": "S\xfctun\xfc sonras\u0131na yap\u0131\u015ft\u0131r",
    "Paste column before": "S\xfctun\xfc \xf6ncesine yap\u0131\u015ft\u0131r",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "D\xfcz metin modunda yap\u0131\u015ft\u0131r. Bu se\xe7ene\u011fi kapatana kadar i\xe7erikler d\xfcz metin olarak yap\u0131\u015ft\u0131r\u0131l\u0131r.",
    "Paste or type a link": "Bir ba\u011flant\u0131 yap\u0131\u015ft\u0131r\u0131n ya da yaz\u0131n.",
    "Paste row after": "Sonras\u0131na sat\u0131r  yap\u0131\u015ft\u0131r",
    "Paste row before": "\xd6ncesine sat\u0131r yap\u0131\u015ft\u0131r",
    "Paste your embed code below:": "Medya g\xf6mme kodunu buraya yap\u0131\u015ft\u0131r:",
    "People": "\u0130nsan",
    "Plugins": "Eklentiler",
    "Plugins installed ({0}):": "Y\xfckl\xfc eklenti ({0}):",
    "Powered by {0}": "Sa\u011flay\u0131c\u0131 {0}",
    "Pre": "Pre",
    "Preferences": "Tercihler",
    "Preformatted": "\xd6nceden bi\xe7imlendirilmi\u015f",
    "Premium plugins:": "Premium eklentileri",
    "Press the Up and Down arrow keys to resize the editor.": "D\xfczenleyiciyi yeniden boyutland\u0131rmak i\xe7in Yukar\u0131 ve A\u015fa\u011f\u0131 ok tu\u015flar\u0131na bas\u0131n.",
    "Press the arrow keys to resize the editor.": "D\xfczenleyiciyi yeniden boyutland\u0131rmak i\xe7in ok tu\u015flar\u0131na bas\u0131n.",
    "Press {0} for help": "Yard\u0131m i\xe7in {0} tu\u015funa bas\u0131n",
    "Preview": "\xd6nizleme",
    "Previous": "Geri",
    "Print": "Yazd\u0131r",
    "Print...": "Yazd\u0131r...",
    "Purple": "Mor",
    "Quotations": "Al\u0131nt\u0131",
    "R": "K",
    "Range 0 to 255": "0 ile 255 aral\u0131\u011f\u0131",
    "Red": "K\u0131rm\u0131z\u0131",
    "Red component": "K\u0131rm\u0131z\u0131 par\xe7a",
    "Redo": "Yinele",
    "Remove": "Kald\u0131r",
    "Remove color": "Rengi kald\u0131r",
    "Remove link": "Ba\u011flant\u0131y\u0131 kald\u0131r",
    "Replace": "De\u011fi\u015ftir",
    "Replace all": "T\xfcm\xfcn\xfc de\u011fi\u015ftir",
    "Replace with": "Bununla de\u011fi\u015ftir",
    "Resize": "Yeniden Boyutland\u0131r",
    "Restore last draft": "Son tasla\u011f\u0131 kurtar",
    "Reveal or hide additional toolbar items": "Ek ara\xe7 \xe7ubu\u011fu \xf6\u011felerini g\xf6ster veya gizle",
    "Rich Text Area": "Zengin Metin Alan\u0131",
    "Rich Text Area. Press ALT-0 for help.": "Zengin Metin Alan\u0131. Yard\u0131m i\xe7in Alt-0'a bas\u0131n.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Zengin Metin Alan\u0131. Men\xfc i\xe7in ALT-F9 k\u0131sayolunu kullan\u0131n. Ara\xe7 \xe7ubu\u011fu i\xe7in ALT-F10 k\u0131sayolunu kullan\u0131n. Yard\u0131m i\xe7in ALT-0 k\u0131sayolunu kullan\u0131n.",
    "Ridge": "\xc7\u0131k\u0131nt\u0131",
    "Right": "Sa\u011f",
    "Right to left": "Sa\u011fdan sola",
    "Row": "Sat\u0131r",
    "Row clipboard actions": "Sat\u0131r panosu eylemleri",
    "Row group": "Sat\u0131r grubu",
    "Row header": "Sat\u0131r ba\u015fl\u0131\u011f\u0131",
    "Row properties": "Sat\u0131r \xf6zellikleri",
    "Row type": "Sat\u0131r tipi",
    "Rows": "Sat\u0131rlar",
    "Save": "Kaydet",
    "Save (if save plugin activated)": "Kaydet (Kay\u0131t eklentisi aktif ise)",
    "Scope": "Kapsam",
    "Search": "Ara",
    "Select all": "T\xfcm\xfcn\xfc se\xe7",
    "Select...": "Se\xe7...",
    "Selection": "Se\xe7im",
    "Shortcut": "K\u0131sayol",
    "Show blocks": "Bloklar\u0131 g\xf6r\xfcnt\xfcle",
    "Show caption": "Ba\u015fl\u0131\u011f\u0131 g\xf6ster",
    "Show invisible characters": "G\xf6r\xfcnmez karakterleri g\xf6ster",
    "Size": "Boyut",
    "Solid": "Kat\u0131",
    "Source": "Kaynak",
    "Source code": "Kaynak kodu",
    "Special Character": "\xd6zel karakter",
    "Special character...": "\xd6zel karakter...",
    "Split cell": "H\xfccreleri ay\u0131r",
    "Square": "Kare",
    "Start list at number": "Listeyi \u015fu say\u0131dan ba\u015flat",
    "Strikethrough": "\xdcst\xfc \xe7izgili",
    "Style": "Stil",
    "Subscript": "Alt simge",
    "Superscript": "\xdcst simge",
    "Switch to or from fullscreen mode": "Tam ekran moduna ge\xe7 veya \xe7\u0131k",
    "Symbols": "Semboller",
    "System Font": "Sistem Yaz\u0131 Tipi",
    "Table": "Tablo",
    "Table caption": "Tablo altyaz\u0131s\u0131",
    "Table properties": "Tablo \xf6zellikleri",
    "Table styles": "Tablo stilleri",
    "Template": "Tema",
    "Templates": "\u015eablonlar",
    "Text": "Metin",
    "Text color": "Yaz\u0131 rengi",
    "Text color {0}": "Metin rengi {0}",
    "Text to display": "G\xf6r\xfcnt\xfclenecek metin",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "Girdi\u011finiz URL bir e-posta adresi gibi g\xf6z\xfck\xfcyor. Gerekli olan mailto: \xf6nekini eklemek ister misiniz?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "Girdi\u011finiz URL bir d\u0131\u015f ba\u011flant\u0131 gibi g\xf6z\xfck\xfcyor. Gerekli olan http:// \xf6nekini eklemek ister misiniz?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "Girdi\u011finiz URL bir d\u0131\u015f ba\u011flant\u0131 gibi g\xf6z\xfck\xfcyor. Gerekli olan https:// \xf6nekini eklemek ister misiniz?",
    "Title": "Ba\u015fl\u0131k",
    "To open the popup, press Shift+Enter": "Popup'\u0131 a\xe7mak i\xe7in Shift+Enter'a bas\u0131n",
    "Toggle accordion": "Akordeon'u de\u011fi\u015ftir",
    "Tools": "Ara\xe7lar",
    "Top": "\xdcst",
    "Travel and Places": "Gezi ve Yerler",
    "Turquoise": "Turkuaz",
    "Underline": "Alt\u0131 \xe7izili",
    "Undo": "Geri al",
    "Upload": "Y\xfckle",
    "Uploading image": "Resim y\xfckleniyor",
    "Upper Alpha": "B\xfcy\xfck Harf",
    "Upper Roman": "B\xfcy\xfck Roman",
    "Url": "Url",
    "User Defined": "Kullan\u0131c\u0131 Tan\u0131ml\u0131",
    "Valid": "Ge\xe7erli",
    "Version": "S\xfcr\xfcm",
    "Vertical align": "Dikey hizalama",
    "Vertical space": "Dikey bo\u015fluk",
    "View": "G\xf6r\xfcnt\xfcle",
    "Visual aids": "G\xf6rsel ara\xe7lar",
    "Warn": "Uyar\u0131",
    "White": "Beyaz",
    "Width": "Geni\u015flik",
    "Word count": "Kelime say\u0131s\u0131",
    "Words": "S\xf6zc\xfck",
    "Words: {0}": "Kelime: {0}",
    "Yellow": "Sar\u0131",
    "Yes": "Evet",
    "You are using {0}": "{0} kullan\u0131yorsun.",
    "You have unsaved changes are you sure you want to navigate away?": "Kaydedilmemi\u015f de\u011fi\u015fiklikler var, sayfadan ayr\u0131lmak istedi\u011finize emin misiniz?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Taray\u0131c\u0131n\u0131z panoya direk eri\u015fimi desteklemiyor. L\xfctfen Ctrl+X/C/V klavye k\u0131sayollar\u0131n\u0131 kullan\u0131n.",
    "alignment": "hizalanma",
    "austral sign": "austral i\u015fareti",
    "cedi sign": "cedi i\u015fareti",
    "colon sign": "colon i\u015fareti",
    "cruzeiro sign": "cruzeiro i\u015fareti",
    "currency sign": "para birimi i\u015fareti",
    "dollar sign": "dolar i\u015fareti",
    "dong sign": "dong i\u015fareti",
    "drachma sign": "drahma i\u015fareti",
    "euro-currency sign": "euro para birimi i\u015fareti",
    "example": "\xf6rnek",
    "formatting": "bi\xe7imlendirme",
    "french franc sign": "frans\u0131z frang\u0131 i\u015fareti",
    "german penny symbol": "alman kuru\u015f sembol\xfc",
    "guarani sign": "guarani i\u015fareti",
    "history": "ge\xe7mi\u015f",
    "hryvnia sign": "hrivniya i\u015fareti",
    "indentation": "girinti",
    "indian rupee sign": "hindistan rupisi i\u015fareti",
    "kip sign": "kip i\u015fareti",
    "lira sign": "lira i\u015fareti",
    "livre tournois sign": "livre tournois i\u015fareti",
    "manat sign": "manat i\u015fareti",
    "mill sign": "mill i\u015fareti",
    "naira sign": "naira i\u015fareti",
    "new sheqel sign": "yeni \u015fekel i\u015fareti",
    "nordic mark sign": "nordic i\u015fareti",
    "peseta sign": "peseta i\u015fareti",
    "peso sign": "peso i\u015fareti",
    "ruble sign": "ruble i\u015fareti",
    "rupee sign": "rupi i\u015fareti",
    "spesmilo sign": "spesmilo i\u015fareti",
    "styles": "stiller",
    "tenge sign": "tenge i\u015fareti",
    "tugrik sign": "tugrik i\u015fareti",
    "turkish lira sign": "t\xfcrk liras\u0131 i\u015fareti",
    "won sign": "won i\u015fareti",
    "yen character": "yen karakteri",
    "yen/yuan character variant one": "yen/yuan karakter de\u011fi\u015fkeni",
    "yuan character": "yuan karakteri",
    "yuan character, in hong kong and taiwan": "yuan karakteri, hong kong ve tayvan'da kullan\u0131lan",
    "{0} characters": "{0} karakter",
    "{0} columns, {1} rows": "{0} s\xfctun, {1} sat\u0131r",
    "{0} words": "{0} kelime"
});